import {FieldConfig} from '../../dynamic-field/field.config';
import {AbstractControl, AsyncValidatorFn, ValidatorFn, Validators} from '@angular/forms';
import {SignatureFieldConfig} from './signature-field.config';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import {of} from "rxjs";


export const signatureFieldControlBuilder: ControlBuilder = (fieldConfig: SignatureFieldConfig, formBuilder) => {
    const { disabled, value, required } = fieldConfig;
    const validators = buildDefaultValidators(fieldConfig);
    const asyncValidators = required ? [signatureRequiredAsyncValidator()] : []; // Attach only if required

    return formBuilder.control(
        {
            disabled,
            value,
        },
        validators,
        asyncValidators
    );
};


export function signatureRequiredAsyncValidator() : AsyncValidatorFn{
    return (control: AbstractControl) => {
        const isEmpty =
            !control.value ||
            !control.value.pointGroups ||
            control.value.pointGroups.length === 0;

        return of(isEmpty ? { required: true } : null);
    };
}
